var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBordeauxNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52817 3.27151C7.19621 3.2695 6.87525 3.39052 6.62726 3.61123C6.37927 3.83194 6.22183 4.13669 6.18532 4.46665C6.0376 5.89008 5.95703 8.03865 5.95703 8.64294C5.95703 12.1612 8.64275 14.0144 11.9999 14.0144C15.357 14.0144 18.0427 12.1612 18.0427 8.64294C18.0427 8.03865 17.9622 5.95723 17.8145 4.46665C17.7779 4.13669 17.6206 3.83194 17.3725 3.61123C17.1245 3.39052 16.8036 3.2695 16.4716 3.27151H7.52817Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 7.2998H18.0035",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0146V20.7289",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31445 20.7285H14.6859",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordeauxNew);
export default __webpack_public_path__ + "static/media/BordeauxNew.06a9987313c4830bf3d5e5557e11ee64.svg";
export { ForwardRef as ReactComponent };